/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Brokers_UnassignedInputs */

const cs_calendar_brokers_unassigned = /** @type {(inputs: Calendar_Brokers_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepřiřazeno`)
};

const en_calendar_brokers_unassigned = /** @type {(inputs: Calendar_Brokers_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

/**
* | output |
* | --- |
* | "Unassigned" |
*
* @param {Calendar_Brokers_UnassignedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_brokers_unassigned = /** @type {((inputs?: Calendar_Brokers_UnassignedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Brokers_UnassignedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_brokers_unassigned(inputs)
	return cs_calendar_brokers_unassigned(inputs)
});